const amountOfAiImagesOnPage = 24;

export default amountOfAiImagesOnPage;
